import {
	OFFICE_SETTINGS_FETCH_SUCCESS,
	OFFICE_SETTINGS_FETCH_FAILURE,
	OFFICE_SETTINGS_FETCH_REQUEST,
} from './officeSettingsConstants';
import {isLoadingProcessor, isNotLoadingProcessor} from '_app/shared/processors/isLoadingProcessors';

const defaultState = {
	isLoading: false,
	data: {
		officeID: null,
		partnerID: null,
		compliance: false,
		isComplianceParent: false,
		disclaimer: null,
		emailMarketing: true,
		socialMarketing: true,
		isFirmBrandingEnabled: false,
		firmName: null,
		phone: null,
		email: null,
		website: null,
		facebook: null,
		twitter: null,
		linkedin: null,
		campaignAutomation: true,
		videoDownload: false,
		complianceDownload: false,
		landingPages: false,
		locations: []
	}
};

export default function (state = defaultState, action) {
	switch (action.type) {
		case OFFICE_SETTINGS_FETCH_REQUEST:
			return isLoadingProcessor(state);
		case OFFICE_SETTINGS_FETCH_FAILURE:
			return isNotLoadingProcessor(state);
		case OFFICE_SETTINGS_FETCH_SUCCESS:
			return {
				...isNotLoadingProcessor(state),
				data: action.data
			};
		default:
			return state;
	}
}